/**
 * Context Engineering Prompt Templates
 * Ready-to-use prompts for setting up GitHub Copilot chatmodes and workflows
 * This is a stub for the prompts used in context-engineering presentations
 */

export interface PromptTemplate {
  id: string
  title: string
  description: string
  tags: string[]
  prompt: string
}

export const contextEngineeringPrompts = {
  agents: {
    architect: {
      id: 'agent-architect',
      title: 'Software Architect Agent',
      description: 'Expert in system design, architecture patterns, and technical decision-making',
      tags: ['Architecture', 'Design Patterns', 'System Design'],
      prompt: 'Full prompt content would go here...'
    } as PromptTemplate,
    frontend: {
      id: 'agent-frontend',
      title: 'Frontend Developer Agent',
      description: 'Specialist in modern frontend development with React, TypeScript, and UI/UX',
      tags: ['React', 'TypeScript', 'UI/UX', 'Performance'],
      prompt: 'Full prompt content would go here...'
    } as PromptTemplate,
    backend: {
      id: 'agent-backend',
      title: 'Backend Developer Agent',
      description: 'Expert in server-side development, APIs, databases, and scalable systems',
      tags: ['Node.js', 'APIs', 'Databases', 'Scalability'],
      prompt: 'Full prompt content would go here...'
    } as PromptTemplate,
    qa: {
      id: 'agent-qa',
      title: 'QA & Review Agent',
      description: 'Quality assurance specialist for code reviews, testing, and documentation',
      tags: ['Testing', 'Code Review', 'Quality', 'Documentation'],
      prompt: 'Full prompt content would go here...'
    } as PromptTemplate,
  },
  workflows: {
    git: {
      id: 'workflow-git',
      title: 'Git Workflow & Branching Strategy',
      description: 'Professional Git workflow with conventional commits and branch management',
      tags: ['Git', 'Version Control', 'Collaboration'],
      prompt: 'Full prompt content would go here...'
    } as PromptTemplate,
    tdd: {
      id: 'workflow-tdd',
      title: 'Test-Driven Development (TDD)',
      description: 'Red-Green-Refactor cycle for quality code development',
      tags: ['TDD', 'Testing', 'Quality'],
      prompt: 'Full prompt content would go here...'
    } as PromptTemplate,
    specDriven: {
      id: 'workflow-spec-driven',
      title: 'Specification-Driven Development',
      description: 'Define clear specifications before implementation',
      tags: ['Specifications', 'Documentation', 'Planning'],
      prompt: 'Full prompt content would go here...'
    } as PromptTemplate,
    reviewing: {
      id: 'workflow-reviewing',
      title: 'Code Review Best Practices',
      description: 'Comprehensive code review process for quality assurance',
      tags: ['Code Review', 'Quality', 'Collaboration'],
      prompt: 'Full prompt content would go here...'
    } as PromptTemplate,
  },
  taskManagement: {
    id: 'task-management',
    title: 'AI-Powered Task Management',
    description: 'Use AI to break down, track, and manage development tasks',
    tags: ['Task Management', 'Planning', 'Organization'],
    prompt: 'Full prompt content would go here...'
  } as PromptTemplate,
  masterAgent: {
    id: 'master-agent',
    title: 'Master Orchestrator Agent',
    description: 'Coordinates all specialized agents and manages workflows',
    tags: ['Orchestration', 'Coordination', 'Management'],
    prompt: 'Full prompt content would go here...'
  } as PromptTemplate,
}

export default contextEngineeringPrompts
